import React from 'react';
import ProductItemView from '../ProductItemView';
import sample_management from '../../resource/lis/sample_management.svg';


const SampleManagement = () => {
    return (
        <ProductItemView
            title="Gestión de muestras"
            items={["Derivaciones a laboratorios externos e internos", "Distribución y seguimiento", "Almacenamiento multi sede"]}
            image={sample_management} />
    );
};

export default SampleManagement;